module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"start":{"partner_carousel":{"title":"More content from our partners can be found in the company profiles:"}}}}}}')
  delete Component.options._Ctor
}
